<template>
	<div class="w-100 position-relative" @click="detail">
		<div class="border bg-card position-relative" :style="{backgroundColor: data.card_color_accent}"> 
			<p class="mb-0 font-logo ls-0-5 text-white text-22">{{data.company_name}}</p>
			<div class="position-absolute" style="right: 20px; top: 20px;">
				<img :src="data.company_logo" height="50">
			</div>
			
	    <div class="d-block" style="margin-top: 50px;">
	      <!-- <p class="mb-0 font-extrabold ls-0-5 text-24 text-white">{{data.card_name}}</p> -->
	      <p class="mb-0 font-semibold ls-1-5 text-12 text-white text-truncate">MEMBERSHIP CARD</p>
				<p class="mb-0 font-bold text-16 text-white" style="letter-spacing: 3px !important;">{{ $textSplitter(data.membership_user.uniq_code,4,' ') }}</p>
	    </div>
			<div class="no-ws" style="margin-top: 44px;">
				<div class="row no-gutters">
					<div class="col-8 align-self-end">
						<p class="mb-0 font-bold text-18 text-white d-inline-block align-middle ls-1-5 text-uppercase">{{ data.membership_user.name }}</p>
					</div>
					<div class="col-4 text-right align-self-end">
						<p class="mb-0 lh-1 font-regular ls-0-5 text-10 text-white">VALID UNTIL</p>
						<p class="mb-0 font-extrabold text-16 text-white d-inline-block align-middle ls-0-5">{{ formatDate(data.membership_user.expiry_at) }}</p>
					</div>
				</div>
	    </div>
		</div>
		<div v-if="disabled" class="w-100 py-3 px-4 border bg-card-height position-absolute" style="background-color: rgba(0, 0, 0, 0.75);border-radius: 16px;top:0;">
			<div class="py-3 px-2 radius-0 d-block mb-2" style="background-color: #fff; !important;margin-top:50px">
  			<div class="row no-gutters">
  				<div class="col-3 align-self-center">
      			<div class="bg-orange p-2 rounded-100 d-table mx-auto" style="line-height: 0 !important">
		          <img src="../../../../assets/img/icon/history-white.png" width="15" class="position-relative">
		        </div>
  				</div>
  				<div class="col-9 align-self-center">
		        <div class="mx-2">
				    	<p class="mb-0 text-orange body-2-4">{{$t('warning-message.submit_member.title')}}</p>
				    	<p class="mb-0 body-2-2">{{$t('warning-message.submit_member.message')}}</p>
		        </div>
  				</div>
  			</div>
		  </div>
		</div>
  </div>
</template>
<script>
	import moment from 'moment';
	export default{
		props:{
			data:{
				type:Object
			},
			guest_name:{
				type: String,
				default: 'Guest Name'
			},
			guest_id:{
				type: String,
				default: 'XXX-YYY-ZZZ'
			},
			disabled:{
				type: Boolean,
				default: false
			}
		},
		methods:{
			detail(){
				this.$emit("detail",this.data)
			},
			formatDate(date){
				return moment(date).format("DD/MM/YY")
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/member/MemberCard.vue